// This is a simplified controller index since we're not using Stimulus Loading
import { Application } from "@hotwired/stimulus";

// Import controllers
import MobileMenuController from "./mobile_menu_controller"
import ImageViewerTriggerController from "./image_viewer_trigger_controller"
import ImageViewerModalController from "./image_viewer_modal_controller"
// import ScreenshotPreventionController from "./screenshot_prevention_controller"
// import ScreenshotLoggingController from "./screenshot_logging_controller"
import FavouriteFolderDropdownController from "./favourite_folder_dropdown_controller"
import FavouritesViewerTriggerController from "./favourites_viewer_trigger_controller"
import FavouritesViewerModalController from "./favourites_viewer_modal_controller"
// import FolderUploadController from "./folder_upload_controller"

// Start Stimulus application
const application = Application.start();

// Register controllers
application.register("mobile-menu", MobileMenuController);
application.register("image-viewer-trigger", ImageViewerTriggerController);
application.register("image-viewer-modal", ImageViewerModalController);
// application.register("screenshot-prevention", ScreenshotPreventionController);
// application.register("screenshot-logging", ScreenshotLoggingController);
application.register("favourite-folder-dropdown", FavouriteFolderDropdownController);
application.register("favourites-viewer-trigger", FavouritesViewerTriggerController);
application.register("favourites-viewer-modal", FavouritesViewerModalController);
// application.register("folder-upload", FolderUploadController);

// Make Stimulus available globally for debugging
window.Stimulus = application;

// Debug: Check if Stimulus is working
console.log("=== STIMULUS APPLICATION STARTED ===")
console.log("Registered controllers:", Object.keys(application.controllers))

// If you want to register controllers later:
// Stimulus.register("hello", HelloController); 